module.exports = __webpack_public_path__ + "70de9c0b0813bf4fd3eb06636fa776e0.svg";